import { Component, Input, OnInit } from '@angular/core';
import { AbstractTransport } from '../../../../../models/abstract-transport.model';
import { BaryCardComponent } from '../../../components';
import { CurrencyPipe, NgForOf, NgIf } from '@angular/common';
import { Estimation } from '../../../../../models/estimation.model';
import { Transport } from '../../../../../models/transport.model';
import { TranslateModule } from '@ngx-translate/core';
import { TransportOrder } from '../../../../../models/transport-order.model';
import { QuotationView } from '../../../../../models/quotation-view.model';
import { CartGroupValueComponent } from '../../../components/cart/cart-group-value/cart-group-value.component';

@Component({
  selector: 'jhi-transport-card-bill',
  standalone: true,
  templateUrl: './transport-card-bill.component.html',
  styleUrls: ['./transport-card-bill.component.scss'],
  imports: [BaryCardComponent, CurrencyPipe, NgIf, TranslateModule, CartGroupValueComponent, NgForOf],
})
export class TransportCardBillComponent implements OnInit {
  @Input() public transport!: AbstractTransport;

  public estimation?: Estimation;

  public ngOnInit(): void {
    if (this.transport instanceof Transport) {
      this.estimation = this.transport.estimation;
    }

    if (this.transport instanceof TransportOrder) {
      this.estimation = new Estimation({
        basePrice: this.transport.transportPrice,
        priceHT: this.transport.ht(),
        insurance: this.transport.insurance,
        gazoleTaxRate: this.transport.gazoleTaxRate,
        gazoleTaxAmount: this.transport.gazoleTax,
        pricingOptions: this.transport.pricingOptions(),
      });
    }

    if (this.transport instanceof QuotationView) {
      this.estimation = new Estimation({
        basePrice: this.transport.quotationBasePrice!,
        priceHT: this.transport.quotationPriceHT || this.transport.quotationBasePrice,
        gazoleTaxAmount: this.transport.quotationPriceHT ? this.transport.quotationPriceHT! - this.transport.quotationBasePrice! : undefined,
      });
    }
  }

  public isTransportOrder(t: AbstractTransport): t is TransportOrder {
    return t instanceof TransportOrder;
  }

  public isTransport(t: AbstractTransport): t is Transport {
    return t instanceof Transport;
  }

  public get pricingOptions(): number {
    if (this.estimation?.pricingOptions) {
      return this.estimation?.pricingOptions?.reduce((price, it) => price + it.amount, 0);
    }
    return 0;
  }
}
